(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 93606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88100);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69923);
/* harmony import */ var _layouts_home_HomeLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63519);
/* harmony import */ var _services_StorageService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25229);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Home = function Home() {
  var isOpened = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return true;
  }, []);

  var _useAuth = (0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__/* .useAuth0 */ .D3)(),
      isAuthenticated = _useAuth.isAuthenticated,
      error = _useAuth.error;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var token = _services_StorageService__WEBPACK_IMPORTED_MODULE_4__/* .StorageService.token.getValue */ .V.token.getValue();

    if ((!isAuthenticated || error) && !token) {
      router.push('/login');
      return;
    } //redirect root path to dashboard


    if (isAuthenticated && router.pathname == _constants__WEBPACK_IMPORTED_MODULE_2__/* .RouterPath.root */ .ag.root) {
      router.push(_constants__WEBPACK_IMPORTED_MODULE_2__/* .RouterPath.drops */ .ag.drops);
      return;
    }
  }, [isAuthenticated, error, router]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_layouts_home_HomeLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    isOpened: isOpened,
    children: ''
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(93606);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);